import Static from './components/Static';

export const staticPage = {
  firstLevel: Static,
};